<template>
  <form>
    <v-row class="py-0">
      <v-col class="py-0" cols="12" sm="12" md="11" lg="11">
        <form-edit
          :form="paymentSettlementKasbon"
          :listSettlementKasbon="listSettlementKasbon"
          ref="formEdit"
          v-if="!edit"
        ></form-edit>
        <detail :id="id" :form="paymentSettlementKasbon" v-if="edit"></detail>
      </v-col>
      <v-col cols="12" sm="12" md="1">
        <v-row class="py-0 mb-2" v-if="!edit">
          <v-col cols="12" class="py-0">
            <v-btn
              v-if="$rbac.can('payment-settlement.update')"
              color="success"
              @click="updateItem"
            >
              <v-icon>
                mdi-content-save
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="$rbac.can('payment-settlement.print')"
                  color="success"
                  v-on="on"
                  @click="printJournal"
                >
                  <v-icon>
                    mdi-printer
                  </v-icon>
                </v-btn>
              </template>
              <span>Journal</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit && !paymentSettlementKasbon.hidden">
          <v-col cols="12" class="py-0">
            <v-btn v-if="$rbac.can('payment-settlement.update')" color="success" @click="editItem">
              <v-icon>
                mdi-pencil
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit && !paymentSettlementKasbon.hidden">
          <v-col cols="12" class="py-0">
            <v-btn
              v-if="$rbac.can('payment-settlement.delete')"
              color="error"
              @click.stop="deleteDialog"
            >
              <v-icon>
                mdi-delete
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="!edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="error" v-on="on" @click="cancel">
                  <v-icon>
                    mdi-close
                  </v-icon>
                </v-btn>
              </template>
              <span>Close</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" v-on="on" @click="back">
                  <v-icon>
                    mdi-arrow-left
                  </v-icon>
                </v-btn>
              </template>
              <span>Back</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="blue-grey" dark v-on="on" @click="dialogAuditHistory = true">
                  <v-icon>
                    mdi-history
                  </v-icon>
                </v-btn>
              </template>
              <span>History</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dialog-delete
      :id="id"
      :dialog="dialog"
      :invoiceNumber="paymentSettlementKasbon.formNumber"
      title="Payment Settlement Kasbon"
      @deleteItem="deleteItem"
      @close="close"
    ></dialog-delete>
    <dialog-audit-history
      :dialog="dialogAuditHistory"
      entity-type="PaymentSettlementKasbon"
      :entity-id="id"
      @close="dialogAuditHistory = false"
    ></dialog-audit-history>
  </form>
</template>

<script>
import Detail from "./DetailPaymentSettlementKasbon";
import FormEdit from "./FormPaymentSettlementKasbon";
import DialogDelete from "@/components/DialogDelete";
import DialogAuditHistory from "@/components/DialogAuditHistory.vue";

export default {
  name: "payment-settlement-kasbon-view",
  components: {
    Detail,
    "form-edit": FormEdit,
    "dialog-delete": DialogDelete,
    DialogAuditHistory,
  },
  props: {
    id: {
      type: Number,
      default: () => undefined,
    },
  },
  data: () => ({
    edit: true,
    dialog: false,
    dialogAuditHistory: false,
    listSettlementKasbon: [],
    listCategory: [],
    paymentSettlementKasbon: {},
  }),
  methods: {
    async getPaymentSettlementKasbon() {
      await this.$store.dispatch("paymentSettlementKasbon/getById", this.id).then(response => {
        this.paymentSettlementKasbon = response.data;
        this.getListSettlementKasbon(response.data.employeeId);
      });
    },
    printJournal() {
      this.$router.push({ name: "Journal Payment Settlement Kasbon", params: { id: this.id } });
    },
    back() {
      this.$router.go(-1);
    },
    editItem() {
      this.edit = false;
    },
    updateItem() {
      this.$refs.formEdit.checkJournal();
    },
    deleteItem(id) {
      this.$store.dispatch("paymentSettlementKasbon/delete", id);
      this.dialog = false;
    },
    deleteDialog() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    cancel() {
      this.getPaymentSettlementKasbon();
      this.edit = true;
    },
    async getListSettlementKasbon(id) {
      const response = await this.$store.dispatch("settlementKasbon/getListSettlementKasbon", id);
      if (response.status === 200) {
        this.listSettlementKasbon = response.data;
      }
    },
  },
  created() {
    this.getPaymentSettlementKasbon();
  },
};
</script>

<style></style>
